import type React from 'react';

import type { IdPayoutConfigDto } from '@/services/ws-digital/src/main/resources/rest-api';

import type { Option } from 'src/types';

export enum AdditionalFilter {
  STATE = 'stateFilter',
  PAYOUT_CONFIG = 'payoutConfigFilter',
}

export type FiltersState = {
  [AdditionalFilter.STATE]: Option<string> | null;
  [AdditionalFilter.PAYOUT_CONFIG]: Option<IdPayoutConfigDto> | null;
};

export type FiltersValues = {
  [AdditionalFilter.STATE]?: string;
  [AdditionalFilter.PAYOUT_CONFIG]?: string;
};

export type FilterChangeHandler = <TKey extends keyof FiltersState>({
  getSearchParamValue,
  getStorageValue,
  key,
  value,
}: {
  key: TKey;
  value: FiltersState[TKey];
  getSearchParamValue: (value: FiltersState[TKey]) => string;
  getStorageValue: (value: FiltersState[TKey]) => FiltersValues[TKey];
}) => void;

export type SaveFilter = <TKey extends keyof FiltersValues>(key: TKey, value?: FiltersValues[TKey]) => void;

export type UseFilters = {
  filters: FiltersState;
  setFilters: React.Dispatch<React.SetStateAction<FiltersState>>;
  clearFilters?: () => void;
  saveFilter: SaveFilter;
  onFilterChange: FilterChangeHandler;
  pendingFilters: boolean;
};

export type AdditionalFilterItem<T> = {
  filter: Option<T> | null;
  setFilter: React.Dispatch<React.SetStateAction<Option<T> | null>>;
  filterKey: AdditionalFilter;
  label: string;
  saveFilter: SaveFilter;
};

export type AdditionalFilterItemMulti<T> = Omit<AdditionalFilterItem<T>, 'filter' | 'setFilter'> & {
  filter: Option<T>[] | null;
  setFilter: React.Dispatch<React.SetStateAction<Option<T>[] | null>>;
};

export type InitialAdditionalFilterValues = Partial<Record<AdditionalFilter, string>>;
